import { CarvanaTheme } from '@carvana/theme';
import styled from 'styled-components';
import { imageUrl } from '@/vm/Shared/imageUrl';

export const StepWrapper = styled.div`
  width: 100%;
  background: #f4f8fa;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const BottomNote = styled.div`
  height: auto;
  background-color: white;
  padding: 20px;
  margin: 20px 20px 60px 20px;
  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    text-align: center;
  }
`;

export const BottomImage = styled.div`
  float: left;
  margin: 10px;
  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    float: none;
    text-align: center;
  }
`;

export const BottomText = styled.div`
  float: left;
  font-size: 16px;
  margin-left: 20px;
  & > p {
    color: #757989;
  }
  & > h3 {
    color: #183558;
    font-size: 16px;
    margin-bottom: 0px;
  }
  & > span {
    color: #00aed9;
    cursor: pointer;
  }
  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    margin-left: 0px;
  }
`;

export const GraphicWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-image: url(${imageUrl('line16.png')});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 640px;
  height: 90px;
  margin-bottom: 100px;
  @media (max-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    background-image: url(${imageUrl('line17.png')});
    flex-wrap: wrap;
    flex-direction: column;
    background-size: 170px 436px;
    padding: 15px;
    margin: 0 auto;
    width: 329px;
    height: auto;
  }
`;

export const Icons = styled.div`
  margin: 80px auto 40px auto;
  width: 100%;
`;
